<template>
  <div class="body" :class="{isBottomContactsOpen: isOpen}">
  <div class="mc-page">
    <header class="mc-header">
      <div class="mc-header__wrapper">
        <div class="mc-header__left">
          <router-link v-if="false && page_back" :to="page_back" class="mc-icon-link simulated-hover" aria-label="Назад">
            <svg class="mc-icon-link__image" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#arrow-line-left"></use>
            </svg>
          </router-link>
          <a v-if="back" @click="prevPage" class="mc-icon-link simulated-hover" aria-label="Назад">
            <svg class="mc-icon-link__image" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#arrow-line-left"></use>
            </svg>
          </a>
          <router-link v-else-if="hidenotify !== true" to="/notifications/" class="mc-icon-link simulated-hover" aria-label="Уведомления">
            <svg class="mc-icon-link__image" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-notification"></use>
            </svg>
          </router-link>
        </div>
        <div class="mc-header__middle">
          <img v-if="is_main_page" class="mc-header__logo-image" src="/assets/svg/logo.svg" width="103" height="24px" alt="">
          <template v-else-if="page_title">{{page_title}}</template>
        </div>
        <div class="mc-header__right">
          <div v-if="searchShow" :class="{isOpen:searchOpen}" class="mc-main-search mc-main-search--second">
            <button @click="openSearch" class="mc-main-search__button-open js-button-open simulated-hover" type="button">
              <svg class="mc-main-search__button-icon" width="30" height="30" viewBox="0 0 30 30">
                <use xlink:href="/assets/svg/sprite.svg#icon-search-1"></use>
              </svg>
            </button>
            <search v-if="searchOpen" @close="closeSearch"></search>
          </div>
          <router-link v-if="hidebasket !== true" to="/basket/" class="mc-icon-link simulated-hover" aria-label="Корзина">
            <svg class="mc-icon-link__image" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-cart"></use>
            </svg>
            <span v-if="counterData.basket && counterData.basket.count > 0" class="mc-icon-link__counter">
                        {{counterData.basket.count}}
                    </span>
          </router-link>
        </div>
      </div>
    </header>
    <main>
      <router-view/>
    </main>
    <nav class="mc-mobile-nav">
      <ul class="mc-mobile-nav__list">
        <li class="mc-mobile-nav__item">
          <router-link to="/" class="mc-mobile-nav__link simulated-hover" active-class="mc-mobile-nav__link--current">
                    <span class="mc-mobile-nav__icon-wrapper">
                        <svg class="mc-mobile-nav__icon" width="20" height="20" viewBox="0 0 20 20">
                            <use xlink:href="/assets/svg/sprite.svg#icon-home"></use>
                        </svg>
                    </span>
            Главная
          </router-link>
        </li>
        <li class="mc-mobile-nav__item">
          <router-link to="/catalog/" class="mc-mobile-nav__link simulated-hover" active-class="mc-mobile-nav__link--current">
                    <span class="mc-mobile-nav__icon-wrapper">
                        <svg class="mc-mobile-nav__icon" width="20" height="20" viewBox="0 0 20 20">
                            <use xlink:href="/assets/svg/sprite.svg#icon-menu"></use>
                        </svg>
                    </span>
            Каталог
          </router-link>
        </li>
        <li class="mc-mobile-nav__item">
          <router-link to="/category/new/" class="mc-mobile-nav__link simulated-hover" active-class="mc-mobile-nav__link--current">
                    <span class="mc-mobile-nav__icon-wrapper">
                        <svg class="mc-mobile-nav__icon" width="20" height="20" viewBox="0 0 20 20">
                            <use xlink:href="/assets/svg/sprite.svg#icon-stars"></use>
                        </svg>
                    </span>
            Новинки
          </router-link>
        </li>
        <li class="mc-mobile-nav__item">
          <router-link to="/category/sale/" class="mc-mobile-nav__link simulated-hover" active-class="mc-mobile-nav__link--current">
                    <span class="mc-mobile-nav__icon-wrapper">
                        <svg class="mc-mobile-nav__icon" width="20" height="20" viewBox="0 0 20 20">
                            <use xlink:href="/assets/svg/sprite.svg#icon-sale"></use>
                        </svg>
                    </span>
            SALE
          </router-link>
        </li>
        <li class="mc-mobile-nav__item">
          <router-link to="/brand/" class="mc-mobile-nav__link simulated-hover" active-class="mc-mobile-nav__link--current">
                    <span class="mc-mobile-nav__icon-wrapper">
                        <svg class="mc-mobile-nav__icon" width="20" height="20" viewBox="0 0 20 20">
                            <use xlink:href="/assets/svg/sprite.svg#brand"></use>
                        </svg>
                    </span>
            Бренды
          </router-link>
        </li>
        <li class="mc-mobile-nav__item">
          <router-link to="/favorite/" class="mc-mobile-nav__link simulated-hover" active-class="mc-mobile-nav__link--current">
                    <span class="mc-mobile-nav__icon-wrapper">
                        <svg class="mc-mobile-nav__icon" width="20" height="20" viewBox="0 0 20 20">
                            <use xlink:href="/assets/svg/sprite.svg#icon-favorite"></use>
                        </svg>
                    </span>
            Избранное
          </router-link>
        </li>
        <li class="mc-mobile-nav__item">
          <router-link :to="isAuth?'/profile/':'/auth/'" class="mc-mobile-nav__link simulated-hover" active-class="mc-mobile-nav__link--current">
                    <span class="mc-mobile-nav__icon-wrapper">
                        <svg class="mc-mobile-nav__icon" width="20" height="20" viewBox="0 0 20 20">
                            <use xlink:href="/assets/svg/sprite.svg#icon-user"></use>
                        </svg>
                    </span>
            Профиль
          </router-link>
        </li>
      </ul>
    </nav>
    <div class="mc-bottom-contacts" :class="isOpen?'isOpen':''">
      <button @click="isOpen=true" class="mc-bottom-contacts__open-button js-button-open simulated-hover" type="button" aria-label="Меню контактов">
        <svg class="mc-bottom-contacts__button-icon" width="24" height="24" viewBox="0 0 24 24">
          <use xlink:href="/assets/svg/sprite.svg#icon-phone"></use>
        </svg>
      </button>
      <div class="mc-bottom-contacts__body">
        <div class="mc-bottom-contacts__inner">
          <button @click="isOpen=false" class="mc-bottom-contacts__close-button js-button-close simulated-hover" type="button" aria-label="Закрыть">
            <svg class="mc-bottom-contacts__close-icon" width="30" height="30" viewBox="0 0 30 30">
              <use xlink:href="/assets/svg/sprite.svg#icon-cross"></use>
            </svg>
          </button>
          <ul class="mc-bottom-contacts__list">
            <li class="mc-bottom-contacts__item">
              <a class="mc-bottom-contacts__link" @click="tel_open('+78005552748')">
                <svg class="mc-bottom-contacts__icon" width="20" height="20" viewBox="0 0 20 20">
                  <use xlink:href="/assets/svg/sprite.svg#icon-phone-fill"></use>
                </svg>
                <span class="mc-bottom-contacts__name">
                                Позвонить консультанту
                            </span>
              </a>
            </li>
            <li class="mc-bottom-contacts__item">
              <a class="mc-bottom-contacts__link" target="_blank" href="https://wa.me/+79214245120">
                <svg class="mc-bottom-contacts__icon" width="20" height="20" viewBox="0 0 20 20">
                  <use xlink:href="/assets/svg/sprite.svg#icon-wa-fill"></use>
                </svg>
                <span class="mc-bottom-contacts__name">
                                Написать в WhatsApp
                            </span>
              </a>
            </li>
            <li class="mc-bottom-contacts__item">
              <a class="mc-bottom-contacts__link" target="_blank" href="https://t.me/+79313896198">
                <svg class="mc-bottom-contacts__icon" width="20" height="20" viewBox="0 0 20 20">
                  <use xlink:href="/assets/svg/sprite.svg#icon-tg-fill"></use>
                </svg>
                <span class="mc-bottom-contacts__name">
                                Написать в Telegram
                            </span>
              </a>
            </li>
            <li v-if="true || user && user.admin" class="mc-bottom-contacts__item">
              <a class="mc-bottom-contacts__link" @click="copyLink">
                <span class="mc-bottom-contacts__name">
                               Скопировать ссылку
                            </span>
                <textarea style="position: absolute; left:-9999px;" id="url" rows="1" cols="30"></textarea>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import search from "@/views/parts/Search.vue";
import urlopen from "@/mixin/urlopen.vue";

export default {
    name: 'main-layout',
    data: () => ({
      isOpen: false,
      searchOpen: false
    }),
  mixins: [urlopen],
    mounted() {
     this.simuletedHOver('mounted');
    },
  updated() {
    //this.simuletedHOver('updated');
  },
  created() {
      this.fetchCounterData();
  },
  watch: {
    '$route'() {
      this.simuletedHOver('$route');
    },
    '$route.meta'() {
      this.page_title = this.$route.meta.name;
    }
  },
  computed: {
    ...mapGetters([
      'counterData',
      'counterLoading',
      'counterError',
      'gender'
    ]),
    isAuth() {
      return this.$store.getters.isAuth;
    },
    user() {
      return this.$store.getters.user;
    },
    searchShow() {
      return this.$route.meta.search;
    },
        notfound() {
          return this.$store.getters.notfound;
        },
        page_title() {
          if (this.$route.path.indexOf('/category/') != -1 && this.$store.getters.section && this.$store.getters.section.hasOwnProperty('name')) {
            return this.$store.getters.section.name;
          }
          return this.$route.meta.name;
        },
        page_back() {
          if (this.$route.meta.prev == '/category/' && this.$store.getters.product.hasOwnProperty('section_id')) {
            let section_id = this.$store.getters.product.section_id;
            return '/category/'+section_id;
          }
          return this.$route.meta.prev;
        },
      back() {
        return this.$route.meta.back;
      },
        is_main_page() {
          return this.$route.meta.main_page;
        },
        hidebasket() {
          return this.$route.meta.hidebasket;
        },
        hidenotify() {
          return this.$route.meta.hidenotify;
        },
        page() {
          if (this.$route.meta.name)
            return this.$route.meta.name;
          else if (this.$store.getters.breadcrumb_page)
            return this.$store.getters.breadcrumb_page;
          else
            return '';
        },
        breadcrumbs1() {
          if (this.$route.meta.breadcrumbs)
            return this.$route.meta.breadcrumbs;
          else
            return false;
        },
        breadcrumbs2() {
          if (this.$route.meta.breadcrumbs_path && this.$store.getters.breadcrumbs)
            return this.$store.getters.breadcrumbs;
          else
            return false;
        },
        name() {
            return this.$store.getters.user.name;
        }
    },
    methods: {
      ...mapActions([
          'fetchCounterData'
      ]),
      copyLink() {
        var Url = document.getElementById("url");

        var params = new URLSearchParams(window.location.search);

        // добавит или перезапишет параметр gender
        params.set('gender', this.gender);

        var query = params.toString();
        Url.innerHTML = window.location.pathname + (query ? ('?' + query) : '');

        console.log(Url.innerHTML);
        Url.select();
        document.execCommand("copy");
      },
        prevPage() {
            this.$router.go(-1)
        },
        simuletedHOver(source) {
          function touchstart(event)
          {
            this.classList.add("onHover");
          }
          function touchend () {
            let _this = this;
            setTimeout(function () {
              _this.classList.remove("onHover");
            }, 200);
          }
          setTimeout(function () {
            document.querySelectorAll(".simulated-hover").forEach(function (element) {
              element.removeEventListener("touchstart", touchstart);
              //element.removeEventListener("touchend");
              element.addEventListener("touchstart", touchstart, {
                once: true
              });
              element.addEventListener("touchend", touchend, {
                once: true
              });
            });
          }, 100)
        },
      openSearch() {
        this.searchOpen=true;
        document.querySelector("body").classList.add("isMainSearchOpen");
      },
      closeSearch() {
        this.searchOpen=false;
      }
    },
    components: {search}
}
</script>